import React from 'react';
import get from 'lodash.get';
import classNames from 'classnames';
import { sanitize } from 'lib/social';
import Link from 'components/Link';

const block = 'byline-social';

const SOCIAL_PLATFORMS = [
  {
    key: 'instagram', /**
   *
   * @param {string} handle
   */
    url: (handle) => `https://instagram.com/${sanitize(handle)}`,
    icon: 'icon-instagram',
  },
  {
    key: 'facebook', /**
   *
   * @param {string} handle
   */
    url: (handle) => `https://facebook.com/${sanitize(handle)}`,
    icon: 'icon-facebook',
  },
  {
    key: 'twitter', /**
   *
   * @param {string} handle
   */
    url: (handle) => `https://x.com/${sanitize(handle)}`,
    icon: 'icon-twitter',
  },
  {
    key: 'tiktok', /**
   *
   * @param {string} handle
   */
    url: (handle) => `https://tiktok.com/${sanitize(handle)}`,
    icon: 'icon-tiktok',
  },
];

/**
 *
 * @param {object} props
 * @param {object} props.person
 * @param {string} props.additionalClasses
 */
export const BylineSocial = ({
  person = {},
  additionalClasses = '',
}) => {
  const email = get(person, 'email', null);
  const social = get(person, 'socialMediaProfiles', null);
  if (!email && !social) {
    return null;
  }

  return (
    <span className={classNames(block, additionalClasses)} data-test={block}>
      {SOCIAL_PLATFORMS.map(({ key, url, icon }) => (social?.[key] ? (
        <Link
          key={key}
          href={url(social[key])}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(event) => { event.stopPropagation(); }}
          className={`${block}--link`}
          data-test={`${block}--link`}
        >
          <span className={`icon ${icon}`} />
        </Link>
      ) : null))}
      {email && (
        <Link
          href={`mailto:${email.trim()}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(event) => { event.stopPropagation(); }}
          className={`${block}--link`}
          data-test={`${block}--link`}
        >
          <span className="icon icon-email" />
        </Link>
      )}
    </span>
  );
};
